module.exports = __webpack_public_path__ + "static/img/4.f59b557.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/4.png
// module id = /Wqg
// module chunks = 1